import type { AtomModel, FormControlSetting, Font } from '@/app/editor/iframe/atom/Atom.model';
import { Atom } from '@/app/editor/iframe/atom/Atom';
import { BaseAtomRender } from '@/app/editor/iframe/atom/atom-service/render/BaseAtomRender';
import { base } from '@/app/editor/sidebar/constant';

/**
 * GpThirdPartyRenderService
 */
export class GpThirdPartyRenderService extends BaseAtomRender {
  /**
   * renderTemplate override từ Atom
   */
  async renderTemplate() {
    const templateTmp = this.getAtomModel().html;
    const $wrapper = jQuery('<div>' + templateTmp + '</div>');

    let html = $wrapper.html();
    html = this.renderSettings(html);
    this.get$el().html(html);
    // render widget in editor
    let icon = '';
    const $snippets = jQuery('<div />').html(this.atom.getDataBkSettingByKey(base._snippet, this.atom.getIdBk()));
    icon = $snippets.children('.snippet-icon').html();
    if (!icon) {
      icon =
        '<svg width="20" height="20" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15.4475 6C15.1927 6 14.9787 6.19157 14.9506 6.44478L13.0617 23.4448C13.0288 23.741 13.2606 24 13.5586 24H14.5525C14.8073 24 15.0213 23.8084 15.0494 23.5552L16.9383 6.55522C16.9712 6.25903 16.7394 6 16.4414 6H15.4475ZM19.5536 8.64645C19.3583 8.84171 19.3583 9.15829 19.5536 9.35355L24.8464 14.6464C25.0417 14.8417 25.0417 15.1583 24.8464 15.3536L19.5536 20.6464C19.3583 20.8417 19.3583 21.1583 19.5536 21.3536L20.2464 22.0464C20.4417 22.2417 20.7583 22.2417 20.9536 22.0464L27.6464 15.3536C27.8417 15.1583 27.8417 14.8417 27.6464 14.6464L20.9536 7.95355C20.7583 7.75829 20.4417 7.75829 20.2464 7.95355L19.5536 8.64645ZM2.35355 14.6464C2.15829 14.8417 2.15829 15.1583 2.35355 15.3536L9.04645 22.0464C9.24171 22.2417 9.55829 22.2417 9.75355 22.0464L10.4464 21.3536C10.6417 21.1583 10.6417 20.8417 10.4464 20.6464L5.15355 15.3536C4.95829 15.1583 4.95829 14.8417 5.15355 14.6464L10.4464 9.35355C10.6417 9.15829 10.6417 8.84171 10.4464 8.64645L9.75355 7.95355C9.55829 7.75829 9.24171 7.75829 9.04645 7.95355L2.35355 14.6464Z"/></svg>';
    }

    const color = this.get$el().children('.module').attr('data-color');
    const widget = this.get$el().children('.module').attr('data-widget');
    let atomWidth: any = 0;
    if (this.get$el() && this.get$el().width() != undefined) {
      atomWidth = this.get$el().width();
    }
    const maxButtonWidth = atomWidth - 2 * 21; // Subtract by paddings
    const showWidgetType = maxButtonWidth >= 320;
    const showWidgetName = maxButtonWidth >= 250;
    let widgetLabel = widget;

    try {
      const settings: any = this.atom.getDataAtom().formControlSettings;
      if (settings?.length) {
        const widgetSetting = settings.find((item: any) => item.name == 'widget' || item.property == 'data-widget');
        const currentWidget = widgetSetting?.options?.find((x: any) => x.key == widget);
        if (currentWidget) {
          widgetLabel = currentWidget.value;
        }
      }
      const moduleName = this.atom.getLabel();
      const fields: any = this.atom.getSettings();
      if (moduleName == 'Ali Reviews') {
        widgetLabel = this.get$el().children('.module').attr('data-aliname');
        if (fields.length > 0) {
          const widgetIndex = fields.findIndex((x: any) => x.name == 'v6widget');
          if (widgetIndex > -1) {
            const defautValue = fields[widgetIndex]['default_value'];
            if (defautValue !== 'section' && fields[widgetIndex].options) {
              widgetLabel = fields[widgetIndex].options[defautValue];
            }
          }
        }
      }
      if (moduleName == 'LAI AliExpress Reviews') {
        widgetLabel = this.get$el().children('.module').attr('data-widget-name');
        if (fields.length > 0) {
          const widgetIndex = fields.findIndex((x: any) => x.name == 'widget');
          if (widgetIndex > -1) {
            const defautValue = fields[widgetIndex]['default_value'];
            widgetLabel = fields[widgetIndex].options[defautValue];
          }
        }
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
    }

    html = `<div class="gf_uncompile-module-icon" ${
      color ? 'style="background-color:' + color + '"' : ''
    }>${icon} <span class="gf_uncompile-module-name ${
      showWidgetName ? (showWidgetType ? '' : 'hide-type') : 'hide'
    }">${this.atom.getLabel()}${
      widget && widgetLabel ? '<span class="widget"> - ' + widgetLabel + '</span>' : ''
    }</span></div>`;
    this.get$el().find('.module').html(html);

    this.get$el().attr('data-compile', 'false');
  }
}
/**
 * GpThirdParty Class
 */
export class GpThirdParty extends Atom {
  public $el: JQuery;
  /**
   * Thông tin riêng của Atom
   * @returns object watch
   */
  getDataAtom(): AtomModel {
    const data: AtomModel = {
      type: this.getType(),
      id: this.getId(),
      nodeId: this.getIdNode(),
      name: this.getLabel(),
      slug: this.getSlug(),
      groupName: this.getGroupName(),
      settings: this.getSettings(),
      formControlSettings: this.getFormControlSettings(),
      data: this.getDataChilds(),
      html: this.getTemplate(),
      class: '.module-wrap',
      style: this.getStyle(),
      script: this.getScript(),
      libs: this.getLibs(),
      fonts: [] as Array<Font>,
      isAutorenderSetting: this.isAutoRenderSetting(),
      version: 1,
    };
    return data;
  }

  /**
   * getFormControlSettings;
   * @returns setting read/write from left-sidebar to live page replace writeStyle, readStyle
   */
  getFormControlSettings(): Array<FormControlSetting> {
    return [];
  }
  /**
   * check
   * @returns true: change setting after drag
   */
  isAutoRenderSetting() {
    return false;
  }

  /**
   * @override Atom.initAtomRender
   */
  initAtomRender() {
    this.atomRender = new GpThirdPartyRenderService(this);
  }
}
